
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"25","width":"30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.727 10.05v2.666H4.13c-.015-.221-.038-.441-.038-.667 0-5.523 5.19-10 11.59-10 1.205 0 2.364.16 3.455.452A5.475 5.475 0 0123.182.716v3.716c1.542 1.132 2.728 2.606 3.417 4.284H30v4c0 .737-.61 1.333-1.364 1.333H27.04c-.527 2.235-1.92 4.195-3.858 5.618v5.05H19.09v-3.109a13.268 13.268 0 01-3.41.441c-1.186 0-2.33-.154-3.408-.44v3.107h-4.09v-5.05c-1.543-1.131-2.729-2.605-3.417-4.283H2.727C1.223 15.383 0 14.187 0 12.716c0-1.47 1.223-2.667 2.727-2.667","fill":"#111224"}})])
          )
        }
      }
    